export default "__VITE_ASSET__go0Vizsj__"